import { IReceivedDataTableProps } from "./models";
import { Typography } from "@mui/material";

export const ReceivedDataTable = ({
  jsonContentData,
}: IReceivedDataTableProps) => {
  return (
    <Typography sx={{ whiteSpace: "pre-wrap" }}>
      {JSON.stringify(jsonContentData, null, 4)}
    </Typography>
  );
};
